import React from 'react';
import { PopupMenu, PopupMenuList } from 'shared/components/ui/popup-menu';
import { InteractionType } from 'shared/types/data-type';

import { CalendarSyncMenuItems } from './calendar-sync-menu-items';

export type CalendarSyncMenuProps = {
  isSynced: boolean;
  isHidden: boolean;
  onToggleSync: () => void;
  onToggleVisibility: () => void;
  onClose: () => void;
  referenceElement: React.RefObject<HTMLElement>;
};

// The calendar-sync actions for one task, shared by the calendar event card's
// badge and the task-detail header button so the two can't drift apart.
export const CalendarSyncMenu: React.FC<CalendarSyncMenuProps> = ({
  isSynced,
  isHidden,
  onToggleSync,
  onToggleVisibility,
  onClose,
  referenceElement,
}) => {
  const onSyncClick = () => {
    onToggleSync();
    onClose();
  };

  const onVisibilityClick = () => {
    onToggleVisibility();
    onClose();
  };

  return (
    <PopupMenu
      referenceElement={referenceElement}
      onOutside={onClose}
      position="bottom-end"
      interactionType={InteractionType.Task}
    >
      <PopupMenuList>
        <CalendarSyncMenuItems
          isSynced={isSynced}
          isHidden={isHidden}
          onToggleSync={onSyncClick}
          onToggleVisibility={onVisibilityClick}
        />
      </PopupMenuList>
    </PopupMenu>
  );
};
